module.exports = __webpack_public_path__ + "static/media/Passwords-logos_transparent.b9ff53cd.png";